import { ChartData } from '../types'

// API service for fetching data from REST APIs
export interface ApiResponse<T> {
  data: T | null
  error: string | null
  loading: boolean
}

// Mock API URLs
const API_ENDPOINTS = {
  gaugeData: 'https://jsonplaceholder.typicode.com/todos/88',
  barChartData: 'https://jsonplaceholder.typicode.com/posts',
  pieChartData: 'https://jsonplaceholder.typicode.com/users',
}

// API service functions
export const apiService = {
  // Fetch gauge data
  async fetchGaugeData (): Promise<ApiResponse<number>> {
    try {
      const response = await fetch(API_ENDPOINTS.gaugeData)
      if (!response.ok) throw new Error(`HTTP error! status: ${ response.status }`)

      const data = await response.json()
      const gaugeValue = (data.id % 100)
      return { data: gaugeValue, error: null, loading: false }
    } catch (error) {
      return {
        data: null,
        error: error instanceof Error ? error.message : 'Unknown error',
        loading: false
      }
    }
  },

  // Fetch bar chart data - using ChartData interface
  async fetchBarChartData (): Promise<ApiResponse<ChartData[]>> {
    try {
      const response = await fetch(API_ENDPOINTS.barChartData)
      if (!response.ok) throw new Error(`HTTP error! status: ${ response.status }`)

      const data = await response.json()
      const barData: ChartData[] = data.slice(0, 6).map((item: any, index: number) => ({
        name: `Item ${ index + 1 }`,
        value: (item.id * 100) % 5000,
      }))

      return { data: barData, error: null, loading: false }
    } catch (error) {
      return {
        data: null,
        error: error instanceof Error ? error.message : 'Unknown error',
        loading: false
      }
    }
  },

  // Fetch pie chart data - using ChartData interface
  async fetchPieChartData (): Promise<ApiResponse<ChartData[]>> {
    try {
      const response = await fetch(API_ENDPOINTS.pieChartData)
      if (!response.ok) throw new Error(`HTTP error! status: ${ response.status }`)

      const data = await response.json()
      const pieData: ChartData[] = data.slice(0, 4).map((user: any, index: number) => ({
        name: user.name || `User ${ index + 1 }`,
        value: (user.id * 25) % 100,
      }))

      return { data: pieData, error: null, loading: false }
    } catch (error) {
      return {
        data: null,
        error: error instanceof Error ? error.message : 'Unknown error',
        loading: false
      }
    }
  },
}